import { styled } from '../theming';

const diff = (size: number, strokeWidth: number) => `calc(calc(${size}px/2) - ${strokeWidth}px)`;

// Inspired by https://stackoverflow.com/a/69200544
export const StyledSpinner = styled.div<{ size: number; strokeWidth: number }>`
  @keyframes rotate {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(1turn);
    }
  }

  ${({ size }) => ({ width: size, height: size })};
  background-image: conic-gradient(transparent 15%, ${({ color }) => color});
  border-radius: 50%;
  mask: radial-gradient(
    circle ${({ size, strokeWidth }) => diff(size, strokeWidth)},
    transparent 99%,
    #fff 100%
  );
  animation: rotate 1200ms linear infinite;
`;
